import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import type { RunInstrument } from '../hooks/useRunInstruments';

type Props = {
  open: boolean;
  instrument: RunInstrument | null;
  onConfirm: () => void;
  onCancel: () => void;
};

const RerunConfirmDialog: React.FC<Props> = ({
  open,
  instrument,
  onConfirm,
  onCancel
}) => {
  const { t } = useTranslation('calibration');

  const cell = instrument?.cell ?? '—';
  const equipment =
    instrument?.equipmentId ||
    t('runPage.unknownEquipment', { defaultValue: 'Unknown' });

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>
        {t('runPage.rerunTitle', { defaultValue: 'Re-run instrument' })}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('runPage.rerunBody', {
            defaultValue:
              'Start a new calibration run for {{equipment}} in cell {{cell}}. Make sure the instrument is still racked in position {{cell}} before continuing.',
            cell,
            equipment
          })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>
          {t('runPage.cancel', { defaultValue: 'Cancel' })}
        </Button>
        <Button onClick={onConfirm} variant="contained" color="primary">
          {t('runPage.rerunConfirm', { defaultValue: 'Start re-run' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RerunConfirmDialog;
